<template>

	<v-container v-if="hasDocuments" class="pa-0">
		<v-row v-for="(document, i) in this.$props.documents" :key="'doc' + i" class="my-4 cellIconContainer">
			<a v-if="document.type == 'LINK'" :href="document.link" class="linkPrimary" target="_blank">
				<span class="material-icons iconSize36 iconMarginRight cellIcon">link</span>
				<span>{{ document.displayName }}</span>
			</a>
			<a v-if="document.type == 'PDF'" :href="document.fileName" class="linkPrimary" target="_blank">
				<span class="material-icons iconSize36 iconMarginRight cellIcon">description</span>
				<span>{{ document.displayName }}</span>
			</a>
		</v-row>
	</v-container>

	<v-container v-else class="pa-0">
		{{ $t("lesson.documentsEmpty") }}
	</v-container>

</template>

<script>
export default {
	name: "Documents",
	props: {
		documents: {
			type: Array
		}
	},
	computed: {
		hasDocuments() {
			return this.$props.documents != null;
		}
	}
}
</script>

<style lang="scss" scoped>

	@import '@/assets/scss/_definitions.scss';

	.cellIconContainer {
		vertical-align: middle;

		.linkPrimary {
			font-size: $fontSize14;
			font-weight: 600;
			@include skinColor(color, --skinColSec, $skinColSec);

			.cellIcon {
				color: $globColSec;
			}
		}
	}

</style>
